import { Select } from "antd"
import { useEffect, useState } from 'react';
import {  getknowledgeSpecialty } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props  {
    onChange: (value : string) => void,
    onClear: () => void,
    size? : SizeType,
    mode?:any,
    defaultValue? : string,
    style? : any
}

const SelectKnowledgeSpecialty = (props: Props) => {
    const [knowledgeAre, setknowledgeAre] = useState([]);
    useEffect(() => {
        const get_knowledgeSpecialty = async () => {
            const knowledgeSpecialtyData = await getknowledgeSpecialty();
            setknowledgeAre(knowledgeSpecialtyData.map((knowledgeSpecialtyData: any) => {
                return {
                    value: knowledgeSpecialtyData.id,
                    label: knowledgeSpecialtyData.ESPECIALIDAD_DE_CONOCIMIENTO
                }
            }));
        }
        get_knowledgeSpecialty();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
                {...props}
                size={props.size}
                labelInValue
                allowClear
                defaultValue={props?.defaultValue}
                style={props.style}
                onChange={(value:any) => {
                    props.onChange(value);
                }}
                onClear={()=>{
                    props.onClear();
                }}
                options={knowledgeAre}
            />        
        </div>
    );
}

export default SelectKnowledgeSpecialty